function horizons_refresh_cart() {
    import('@theme/events').then(({ CartUpdateEvent }) => {
      const cartDrawer = document.querySelector('cart-drawer-component');    
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'fad-refresh',
          sections: {}
        });
        document.dispatchEvent(event);
        if (cartDrawer?.hasAttribute('auto-open')) {
          cartDrawer.open();
        }
      });
    });
}


function wishlist_remove_and_update_cart(variant_id) {
    var actions = {};
    actions[variant_id] = 0;

    //$("#checkout")[0].disabled = true;

    // we need to find the section name for the checkout buttons
    // eg shopify-section-template--24410371686779__cart-footer
    const dom = document.querySelectorAll("*");
    let section_name = "";
    dom.forEach(
        function(node, index) {
            if (node.classList.contains('cart__footer-wrapper')) {
                //alert("Found the badger!");
                //console.log(node);
                section_id = node.attributes['id'].value;
                section_name = section_id.replace("shopify-section-","");
                //console.log("got section_name=" + section_name);            
            }
        }
    );
    //console.log("section_name is " + section_name);

    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { 
          updates: actions,
          sections: section_name+',main-cart-items,main-cart-footer'
        },
        dataType: 'json',
        success: function(stuff) {
            horizons_refresh_cart();
            wishlist_refresh();
            refresh_motivator();
        }
    };
  
    $.ajax(params);
}

function wishlist_refresh() {
    var params = {
        type: "GET",
        url: 'https://store.3dtotal.com/tools/downloadables/wishlist/list.php?template=tinker',
        data: {
            partial_mode: 'true',
            theme: 'tinker-3dtotal'
        },
        success: function(stuff) {
            //data_id = "shopify-section-" + $("#wishlist-section")[0].getAttribute('data-id');
            //$("#"+data_id)[0].innerHTML = stuff['sections']['main-cart-items'];
            //alert("got " + stuff);
            if ($(".wishlist-section").length>0) {
                $(".wishlist-section")[0].innerHTML = stuff;
            }
            wishlist_update_buttons();
        }
    }
    //alert("wishlist_refresh()");
    $.ajax(params);
}

function wishlist_save_for_later(variant_id) {
    //alert("wishlist_save_for_later(" + variant_id + ")");
    //$("#checkout")[0].disabled = true;

    $.post("/tools/downloadables/wishlist/add.php",
        { variant_id: variant_id },
        function(data, status) {
            //alert("got response " + data);
            //alert("wishlist_save_for_later!");
            //remove this item from the cart, and refresh cart...
            wishlist_remove_and_update_cart(variant_id);
        }
    );
}

function wishlist_remove_from_wishlist_prompt(variant_id, reason = 'removed') {
    //alert("wishlist_remove_from_cart(" + variant_id + ")");
    if (confirm("Are you sure you wish to remove this item from your wishlist?")) {
        $.post("/tools/downloadables/wishlist/remove.php",
            { variant_id: variant_id, reason: reason },
            function(data, status) {
                wishlist_remove_from_wishlist(variant_id, reason);
            }
        );
    }
}

function wishlist_add_to_cart(variant_id) {
    var actions = {};
    actions[variant_id] = 1;

    //$("#checkout")[0].disabled = true;

    // we need to find the section name for the checkout buttons
    // eg shopify-section-template--24410371686779__cart-footer
    const dom = document.querySelectorAll("*");
    let section_name = "";
    dom.forEach(
        function(node, index) {
            if (node.classList.contains('cart__footer-wrapper')) {
                //alert("Found the badger!");
                //console.log(node);
                section_id = node.attributes['id'].value;
                section_name = section_id.replace("shopify-section-","");
                //console.log("got section_name=" + section_name);            
            }
        }
    );
    //console.log("section_name is " + section_name);

    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { 
          updates: actions,
          sections: section_name+',main-cart-items,main-cart-footer,cart-items,cart-footer'
        },
        dataType: 'json',
        success: function(stuff) { 
            wishlist_remove_from_wishlist(variant_id, 'added_to_cart');

            horizons_refresh_cart();

            perform_promotion_group_offer_check();

            refresh_motivator();
        }
      };
      //alert("modifying cart!");
    $.ajax(params);
}

function wishlist_remove_from_wishlist(variant_id, reason = "removed") {
    //alert("wishlist_remove_from_wishlist(" + variant_id + ")");
    $.post("/tools/downloadables/wishlist/remove.php",
        { variant_id: variant_id, reason: reason },
        function(data, status) {
            //alert("got response " + data);
            //remove this item from the cart, and refresh cart...
            //wishlist_remove_and_update_cart(variant_id);
            //alert("remove_from_wishlist!");
            wishlist_refresh();
            refresh_motivator();
        }
    );
    //$.ajax(params);
}

function wishlist_update_buttons() {
    $.post("/tools/downloadables/wishlist/get_variants_in_wishlist.php",
        {},
        function(data, status) {
            variant_ids = data;
            if (!Array.isArray(variant_ids))
                return;
            variant_ids.forEach(function(variant_id) {
                results = $(".save-for-later-id-"+variant_id);
                if (results.length>0) {
                    results[0].innerHTML = "In your <a class='wishlist-link link' href='/cart#wishlist'>wishlist!</a>";
                }
            });
        }
    );
}

var wishlist_general_refreshed_on_load = false;

(function($) {
    if (!wishlist_general_refreshed_on_load) {
        wishlist_refresh();
        wishlist_general_refreshed_on_load = true;
    }
})(jQuery);